import { ReactNode } from 'react';

export interface IconSvgDef {
  viewBox: string;
  path: ReactNode;
}

export const circleSpinner: IconSvgDef = {
  viewBox: '0 0 67 67',
  path: (
    <>
      {/* Anel/base */}
      <path
        d="M66.8332 33.3333C66.8332 51.7428 51.9093 66.6667 33.4998 66.6667C15.0903 66.6667 0.166504 51.7428 0.166504 33.3333C0.166504 14.9238 15.0903 0 33.4998 0C51.9093 0 66.8332 14.9238 66.8332 33.3333ZM10.0004 33.3333C10.0004 46.3117 20.5214 56.8328 33.4998 56.8328C46.4782 56.8328 56.9993 46.3117 56.9993 33.3333C56.9993 20.3549 46.4782 9.83388 33.4998 9.83388C20.5214 9.83388 10.0004 20.3549 10.0004 33.3333Z"
        fill="var(--spinner-base, currentColor)"
        fillOpacity="var(--spinner-base-opacity, 0.35)"
      />
      {/* Arco */}
      <path
        d="M61.9165 33.3333C64.6319 33.3333 66.8703 31.1204 66.4712 28.4344C66.0712 25.7423 65.3421 23.1031 64.2958 20.5772C62.6207 16.533 60.1653 12.8584 57.0701 9.76311C53.9748 6.66782 50.3001 4.2125 46.2559 2.53735C43.73 1.49108 41.0909 0.761951 38.3987 0.361951C35.7128 -0.0371247 33.4998 2.20127 33.4998 4.91667C33.4998 7.63207 35.7246 9.78182 38.3807 10.3458C39.7843 10.6438 41.1609 11.0704 42.4929 11.6222C45.344 12.8032 47.9347 14.5341 50.1168 16.7163C52.299 18.8985 54.03 21.4891 55.211 24.3403C55.7627 25.6722 56.1894 27.0489 56.4874 28.4524C57.0514 31.1086 59.2011 33.3333 61.9165 33.3333Z"
        fill="var(--spinner-arc, currentColor)"
      />
    </>
  ),
};